import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { requirePermission } from '~/utils/guards';

const AssetAccessPage = lazy(() => import('~/features/organization/pages/asset-access-page'));

export const Route = createFileRoute('/_authenticated/_tenant/subsidiary/asset-access')({
  beforeLoad: requirePermission('organization_asset_access'),
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <AssetAccessPage />
    </Suspense>
  ),
});
